import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function similar to FlutterFlow

const modifyPartner = async (
  phone,
  ville,
  postal,
  entreprise,
  partner_type,
  payment_allowed,
  orgid,
  adresse,
  siren,
  email,
  token,
  prefix
) => {
  // Define the endpoint URL
  const url = prefix + `organisations/${orgid}/partner`;

  // Define the request body
  const body = {
    phone: phone,
    ville: ville,
    postal: postal,
    entreprise: entreprise,
    partner_type: partner_type,
    payment_allowed: payment_allowed,
    adresse: adresse,
    siren: siren,
    email: email,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the PUT request to modify the client
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return "";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return;
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document (avoid passing full document references)
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      await response.text(), // response body as string
      "PUT"
    );

    // Check if the request was successful
    if (response.ok) {
      // Handle successful response
      return "Client modified successfully";
    } else {
      // Handle error response
      console.error(`Failed to modify client: ${response.status}`);
      return `Failed to modify client: ${response.status}`;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return `Exception occurred: ${error.message}`;
  }
};

export default modifyPartner;
